// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPlayerEmbeded_videoContainer__2XsFz","videoPlayer":"VideoPlayerEmbeded_videoPlayer__OlsmK","liveLabel":"VideoPlayerEmbeded_liveLabel__3UbR_"};